export const RISK_LEVEL_MAP = {
  high: 3,
  medium: 2,
  low: 1,
};

export enum RISK_LEVEL_ENUM {
  high = 'high',
  medium = 'medium',
  low = 'low',
}

export type RiskLevel = 'high' | 'medium' | 'low';

export function calculateRiskScore(resourceRiskLevel: string, permissionRiskLevel: string) {
  const resource_risk = getRiskLevelFromString(resourceRiskLevel);
  const permission_risk = getRiskLevelFromString(permissionRiskLevel);
  const maxRiskScore = getRiskLevelFromString('high');
  return { riskScore: resource_risk * permission_risk, maxRiskScore: maxRiskScore * maxRiskScore };
}

const getRiskLevelFromString = (riskLevel: string) => {
  const level = riskLevel.toLowerCase();
  if (level in RISK_LEVEL_MAP) {
    return RISK_LEVEL_MAP[level as RiskLevel];
  }
  return 0;
};
